// Client-side access hints. The API remains the authorization authority.
// These helpers accept a legacy single role, a role array, or the authenticated user DTO.
export const ROLES = {
  SUPER_ADMIN: "super_admin", OPERATIONS_MANAGER: "operations_manager",
  CUSTOMER_ACCOUNT_MANAGER: "customer_account_manager", SUPPLIER_ACCOUNT_MANAGER: "supplier_account_manager",
  SUPPORT_AGENT: "support_agent", FINANCE_PREPARER: "finance_preparer",
  FINANCE_APPROVER: "finance_approver", CONTENT_REVIEWER: "content_reviewer",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin", operations_manager: "Operations Manager",
  customer_account_manager: "Customer Account Manager", supplier_account_manager: "Supplier Account Manager",
  support_agent: "Support Agent", finance_preparer: "Finance Preparer",
  finance_approver: "Finance Approver", content_reviewer: "Content Reviewer",
};

export const ASSIGNABLE_ROLES = Object.keys(ROLE_LABEL).filter((role) => role !== ROLES.SUPER_ADMIN);

export function rolesFor(subject) {
  if (!subject) return [];
  if (typeof subject === "string") return [subject];
  if (Array.isArray(subject)) return subject;
  const roles = subject.roles || subject.role_names;
  if (Array.isArray(roles) && roles.length) return roles;
  return subject.role ? [subject.role] : [];
}

export function primaryRole(subject) {
  const roles = rolesFor(subject);
  return roles.includes(ROLES.SUPER_ADMIN) ? ROLES.SUPER_ADMIN : roles[0];
}

const ROLE_ACCESS = {
  super_admin: ["*"],
  operations_manager: ["overview", "dashboard", "suppliers", "experiences", "availability", "bookings", "refunds", "support", "reviews"],
  customer_account_manager: ["overview", "dashboard", "customers"],
  supplier_account_manager: ["overview", "dashboard", "suppliers"],
  support_agent: ["overview", "dashboard", "bookings", "customers", "support"],
  finance_preparer: ["overview", "dashboard", "payments"],
  finance_approver: ["overview", "dashboard", "payments"],
  content_reviewer: ["overview", "dashboard", "experiences", "reviews"],
};

export function canAccess(subject, section) {
  return rolesFor(subject).some((role) => {
    const allow = ROLE_ACCESS[role] || [];
    return allow.includes("*") || allow.includes(section);
  });
}

const ACTIONS = {
  super_admin: ["*"],
  operations_manager: ["supplier.approve", "supplier.reject", "supplier.suspend", "supplier.reactivate", "supplier.edit", "document.review", "experience.approve", "experience.reject", "experience.publish", "experience.unpublish", "experience.edit", "availability.edit", "booking.confirm", "booking.cancel", "booking.reschedule", "booking.refund", "booking.note", "case.assign", "case.priority", "case.resolve", "case.close", "case.message", "review.publish", "review.hide", "review.flag"],
  customer_account_manager: ["customer.edit", "customer.note"],
  supplier_account_manager: ["supplier.edit"],
  support_agent: ["booking.confirm", "booking.cancel", "booking.reschedule", "booking.note", "case.assign", "case.priority", "case.resolve", "case.close", "case.message", "customer.note"],
  finance_preparer: ["finance.read", "finance.prepare"],
  finance_approver: ["finance.read", "finance.approve", "finance.execute"],
  content_reviewer: ["experience.approve", "experience.reject", "experience.publish", "experience.unpublish", "review.publish", "review.hide", "review.flag"],
};

export function can(subject, action) {
  return rolesFor(subject).some((role) => {
    const allow = ACTIONS[role] || [];
    return allow.includes("*") || allow.includes(action);
  });
}
